import Vue from 'vue'
import Croppa from 'vue-croppa'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueLocalStorage from 'vue-localstorage'

import App from './App'
import Context from './Context'
import Router from './business/router'
import store from './business/vuex'
import UIUtils from './business/utils/UIUtils'
import Utils from './business/utils/Utils'
import LocalStorage from './business/services/LocalStorage.js'
import Device from './business/services/Device.js'
import VueAnalytics from 'vue-analytics'
import LoggerService from './business/services/LoggerService'

import {
    BootstrapVue,
    TooltipPlugin,
    AvatarPlugin,
    ButtonPlugin,
    FormInputPlugin,
    FormPlugin,
    FormGroupPlugin,
    NavbarPlugin,
    ModalPlugin,
    CardPlugin,
    TablePlugin,
    DropdownPlugin,
    SidebarPlugin,
    ToastPlugin,
    IconsPlugin,
    LinkPlugin
} from 'bootstrap-vue'

import BFormSlider from 'vue-bootstrap-slider'
import KeyboardService from './business/services/KeyboardService'
import VueApexCharts from 'vue-apexcharts'
import './prototypes'
import { AUTH0_CONFIG, ROUTES } from './business/const'
import BackendProvider from './business/services/BackendProvider'
import MainController from './business/controller/MainController'
import { Auth0Plugin } from './business/auth0-plugin'

Vue.use(BootstrapVue, {
    BTooltip: {
        delay: {
            show: 700,
            hide: 300
        }
    },
    BPopover: {
        delay: 700
    }
})

Vue.use(BFormSlider)
Vue.use(IconsPlugin)
Vue.use(AvatarPlugin)
Vue.use(FormPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(NavbarPlugin)
Vue.use(ModalPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(TablePlugin)
Vue.use(DropdownPlugin)
Vue.use(SidebarPlugin)
Vue.use(ToastPlugin)
Vue.use(LinkPlugin)
Vue.use(TooltipPlugin)
Vue.use(VueApexCharts)

require('../scss/common-fairtility.scss')

Vue.use(Croppa)
Vue.use(VueResource)

Vue.use(VueLocalStorage)
LocalStorage.initLocalStorage()

Vue.filter('kb', val => {
    return Math.floor(val / 1024)
})

window.VueUtils = Utils
window.VueUIUtils = UIUtils
window.VueContext = Context

BackendProvider.init()

Vue.$mainController = new MainController()
Vue.prototype.$mainController = Vue.$mainController

Vue.$store = store

Vue.use(VueRouter)

Vue.prototype.$log = LoggerService
Vue.$log = LoggerService

KeyboardService.init()

Device.initDeviceParams()

if (Device.mobileMode) {
    $('html, body').css('overflow-x', 'hidden')

    $('body').css('position', 'relative')
}

Vue.mixin({
    directives: {
        qa: {
            inserted: function (el, binding) {
                if (process.env.NODE_ENV !== 'production') {
                    const { arg, value } = binding
                    el.setAttribute(arg, value)
                }
            }
        }
    },
    computed: {
        $translate() {
            return this.$store.getters['locale/translate']
        },
        $utils() {
            return Utils
        },
        $uiUtils() {
            return UIUtils
        },
        $paths() {
            return ROUTES
        }
    }
})

// and then use it in main.js
Vue.use(VueAnalytics, {
    id: 'UA-212431132-1',
    trackEvent: true,
    Router,
    autoTracking: {
        screenview: true,
        exception: true
    }
})

Vue.use(Auth0Plugin, AUTH0_CONFIG[process.env.NODE_ENV])

// for easy debugging
window.vue = new Vue({
    el: '#app',
    router: Router,
    store,
    components: { App },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                if (to.name) {
                    document.title = 'Fairtility - ' + (to.name || '')
                }
            }
        }
    },
    beforeCreate: function () {
        Context.init(this)
    },
    template: '<App/>'
})
